import React from 'react';

const QrCode: React.FC<React.SVGProps<SVGSVGElement>> = ({ ...props }) => {
  return (
    <svg
      width="40"
      height="40"
      viewBox="0 0 40 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M19 15V8.33337H21V15H19Z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M34 25V18.3334H36V25H34Z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M24 25V18.3334H26V25H24Z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M34 36.6667L34 28.3334L36 28.3334L36 36.6667L34 36.6667Z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M36.6667 31H25V29H36.6667V31Z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M19 36.6667V28.3334H21V36.6667H19Z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M25.6665 36.6667V28.3334H27.6665V36.6667H25.6665Z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M26.6666 21H18.3333V19H26.6666V21Z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M36.6668 24.3334L29.5239 24.3334L29.5239 22.3334L36.6668 22.3334L36.6668 24.3334Z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M14.9999 21L3.33325 21L3.33325 19L14.9999 19V21Z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5.33325 13.2381H13.238V5.33337H5.33325V13.2381ZM15.238 15.2381V3.33337H3.33325V15.2381H15.238Z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5.33325 34.6666H13.238V26.7618H5.33325V34.6666ZM15.238 36.6666V24.7618H3.33325V36.6666H15.238Z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M26.7617 13.2381H34.6665V5.33337H26.7617V13.2381ZM36.6665 15.2381V3.33337H24.7617V15.2381H36.6665Z"
      />
    </svg>
  );
};

export default QrCode;
